<template>
  <!-- Origem Flow: sem o selo de contagem no início da linha — a contagem
       de comentários já aparece na coluna virtual de Comentários; aqui fica
       sempre o botão padrão de expandir, como no ClickUp. -->
  <GridViewRowExpandButton
    :row="row"
    v-bind="$attrs"
    @edit-modal="$emit('edit-modal')"
  />
</template>
<script>
import GridViewRowExpandButton from '@baserow/modules/database/components/view/grid/GridViewRowExpandButton'

export default {
  name: 'GridViewRowExpandButtonWithCommentCount',
  emits: ['edit-modal'],
  components: { GridViewRowExpandButton },
  inject: { $hasPermission: '$hasPermission' },
  props: {
    row: {
      type: Object,
      required: false,
      default: null,
    },
    table: {
      type: Object,
      required: false,
      default: null,
    },
    workspaceId: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  computed: {
    rowCommentCount() {
      if (!this.row || !this.row._ || !this.row._.metadata) {
        return null
      }
      return this.row._.metadata.row_comment_count
    },
  },
  methods: {
    onEditModalClick() {
      this.$emit('edit-modal')
    },
  },
}
</script>
